import { Logo } from '@/components/Logo';
import { styled } from 'styled-components';

import { SideBarContent } from './Content/SideBarContent';
import { SideBarFooter } from './Footer/SideBarFooter';
import { useSideBar } from './useSideBar';

const StyledSideBar = styled.div<{ $isCollapsed?: boolean }>`
  ${({ theme, $isCollapsed }) => `
  display: flex;
  flex-direction: column;
  container-type: inline-size;
  container-name: side-bar;
  width: ${$isCollapsed ? '80px' : '240px'};
  height: 100%;
  background: ${theme.colorBgContainer};
  border-right: ${theme.lineWidth}px ${theme.lineType} ${theme.colorBorder};
  transition: width ${theme.motionDurationMid} ease-in-out;
  flex-grow: 0;

  @container app (width < ${theme.screenXS}px) {
    display: none;
  }
`}
`;

export const SideBar = () => {
  const { isCollapsed, toggleCollapsed } = useSideBar();
  return (
    <StyledSideBar $isCollapsed={isCollapsed}>
      <Logo isCollapsed={isCollapsed} />
      <SideBarContent isCollapsed={isCollapsed} />
      <SideBarFooter
        isCollapsed={isCollapsed}
        toggleCollapsed={toggleCollapsed}
      />
    </StyledSideBar>
  );
};
